import { SET_ERRORS, RESET_REQUEST, SET_HOME, SET_TWITTER, SET_STORIESANDARTICLES, SET_PAGE, SET_SCREENINGS, SET_COMMUNITY } from '../actions/SiteActions';

const initialState = {
    errors: null,
    statusCode: null,
    messages: null,
    home: {},
    twitter: [],
    stories: [],
    articles: [],
    page: {},
    community: {},
    screenings: [],
};

const SiteReducer = (previousState, action) => {
    let state = previousState || initialState;
    if (typeof state.hydrated === 'undefined' || !state.hydrated) {
        state = {
            ...initialState,
            ...previousState,
            hydrated: true,
        };
    }
    switch (action.type) {
        case SET_ERRORS:
            return {
                ...state,
                errors: action.payload,
            };
        case RESET_REQUEST:
            return {
                ...state,
                errors: null,
                statusCode: null,
                messages: null,
            };
        case SET_HOME:
            return {
                ...state,
                home: action.payload,
            };
        case SET_STORIESANDARTICLES:
            return {
                ...state,
                stories: action.payload.stories,
                articles: action.payload.articles,
            };
        // case SET_ARTICLES:
        //     return {
        //         ...state,
        //         articles: action.payload,
        //     };
        case SET_PAGE:
            return {
                ...state,
                page: action.payload,
            };
        case SET_TWITTER:
            return {
                ...state,
                twitter: action.payload,
            };
        case SET_COMMUNITY:
            return {
                ...state,
                community: action.payload,
            };
        case SET_SCREENINGS:
            return {
                ...state,
                screenings: action.payload,
            };
        default:
            return state;
    }
};

export default SiteReducer;
